import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { DEFAULT_DEPTH, MAX_DEPTH } from '@/features/data/lineage/lineage-api';
import { LineageGraphPage } from '@/features/data/lineage/lineage-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Le graphe de lignage d'un jeu (lot L07) : `?namespace=&name=&depth=`. */
export const Route = createFileRoute('/$tenant/lineage/graph')({
  validateSearch: (search: Record<string, unknown>): { namespace: string; name: string; depth?: number } => {
    const depth = Number(search['depth']);
    return {
      namespace: typeof search['namespace'] === 'string' ? search['namespace'] : '',
      name: typeof search['name'] === 'string' ? search['name'] : '',
      ...(Number.isInteger(depth) && depth >= 1 && depth <= MAX_DEPTH && depth !== DEFAULT_DEPTH
        ? { depth }
        : {}),
    };
  },
  component: LineageGraphRoute,
});

function LineageGraphRoute() {
  const { tenant } = Route.useParams();
  const { namespace, name, depth = DEFAULT_DEPTH } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="lineage"
      crumbs={[{ label: t('nav.items.lineage') }, { label: name, mono: true }]}
    >
      <LineageGraphPage
        tenantId={tenant}
        namespace={namespace}
        name={name}
        depth={depth}
        onDepthChange={(next) =>
          void navigate({
            search: { namespace, name, ...(next !== DEFAULT_DEPTH ? { depth: next } : {}) },
            replace: true,
          })
        }
      />
    </ConsoleShell>
  );
}
